import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AnimatedBackground from '../components/AnimatedBackground';
import { fireEvent } from '../utils/funnelEvents';
import ArticleStructuredData from '../components/ArticleStructuredData';
import VerticalHeader from '../components/VerticalHeader';
import ResearchInviteCard from '../components/research/ResearchInviteCard';

import HealthcareHero from './healthcare/HealthcareHero';
import WhatWeAreStudying from './healthcare/WhatWeAreStudying';
import DataNote from './healthcare/DataNote';
import HealthcareFAQ from './healthcare/HealthcareFAQ';
import NotifyMe from './healthcare/NotifyMe';

// Research-first page for a plan that is not shipped. It exists to collect
// interviews and launch signups, and to give outreach a URL. Every claim on
// it is about what we are studying, not what the product does.
const PAGE_TITLE = 'Sortio for Healthcare (In Development): Help Shape It | Sortio';
const PAGE_DESCRIPTION =
  'Sortio for healthcare teams is in development. We are researching how practices handle referrals from fax portals, scans into the chart, records requests, and billing paperwork. Take a 10-minute research interview, get notified at launch.';

const NAV = [
  { href: '#workflows', label: 'What we are studying' },
  { href: '#status', label: 'Where it stands' },
  { href: '#faq', label: 'Questions' },
  { href: '#notify', label: 'Get notified' },
];

const HealthcarePage = () => {
  useEffect(() => {
    fireEvent('team_page_view', { vertical: 'healthcare' });
  }, []);

  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta
          name="keywords"
          content="healthcare document workflow, fax referral intake, medical records organization, patient file management, EHR document attachment, clinic paperwork automation"
        />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.getsortio.com/for-healthcare" />
        <link rel="canonical" href="https://www.getsortio.com/for-healthcare" />
      </Helmet>
      <ArticleStructuredData
        title={PAGE_TITLE}
        description={PAGE_DESCRIPTION}
        datePublished="2026-09-13T00:00:00.000Z"
        dateModified="2026-09-13T00:00:00.000Z"
        authorName="Sortio Team"
      />

      <VerticalHeader verticalLabel="Healthcare" navItems={NAV} />
      <HealthcareHero />

      <div className="relative">
        <AnimatedBackground variant="business" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
          <WhatWeAreStudying />
          <ResearchInviteCard vertical="healthcare" />
          <DataNote />
          <HealthcareFAQ />
          <NotifyMe />
        </div>
      </div>
    </>
  );
};

export default HealthcarePage;
